import { useCallback } from 'react'
import DialogButton from '../../../Common/Buttons/DialogButton'
import Dialog from '../../../Common/Dialog/Dialog'
import DialogActions from '../../../Common/Dialog/DialogActions'
import DialogContent from '../../../Common/Dialog/DialogContent'
import DialogTitle from '../../../Common/Dialog/DialogTitle'
import { DeletePaginationItem } from '../../../UserData/_actions/UserDataActions'
import { useTranslation } from 'react-i18next'
import { type UserCreditCardStore } from '../../../UserData/_stores/UserCreditCardStore'
import { useAppDispatch } from '../../../Common/_hooks/useAppDispatch'

interface Props {
  creditCard: UserCreditCardStore
  opened: boolean
  onClose: () => void
}

export default function DeleteCreditCardDialog(props: Props) {
  const [t] = useTranslation('account-v2')
  const dispatch = useAppDispatch()

  const onConfirm = useCallback(() => {
    const fd = new FormData()
    fd.append('id', String(props.creditCard.get('id')))

    dispatch(DeletePaginationItem(fd, 'creditCards'))
    props.onClose()
  }, [props.creditCard, props.onClose])

  return <Dialog
    open={props.opened}
    maxWidth="xs"
    fullWidth
    onClose={props.onClose}
    showCloseButton
  >
    <DialogTitle>{t('Delete credit card {{name}}', { name: props.creditCard.get('name') })}</DialogTitle>
    <DialogContent>
      <p>{t('Are you sure that you want to delete this credit card?')}</p>
    </DialogContent>
    <DialogActions>
      <DialogButton
        color="secondary"
        onClick={props.onClose}
      >{t('Cancel')}</DialogButton>
      <DialogButton
        color="error"
        onClick={onConfirm}
        autoFocus
      >{t('Delete')}</DialogButton>
    </DialogActions>
  </Dialog>
}
